import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ad97ea0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "check_phone_number_wrapper" }
const _hoisted_2 = { class: "check_phone_number_body" }
const _hoisted_3 = { class: "check_phone_number_title" }
const _hoisted_4 = { class: "check_phone_number_row" }
const _hoisted_5 = {
  key: 0,
  class: "check_phone_number_row"
}
const _hoisted_6 = {
  key: 1,
  class: "check_phone_number_row"
}
const _hoisted_7 = { class: "error_text" }
const _hoisted_8 = { class: "check_phone_number_buttons_wrapper" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_v_input = _resolveComponent("v-input")
  const _directive_maska = _resolveDirective("maska")
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('check_phone_number.title')), 1),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_component_v_input, {
          ref: "newPhoneInput",
          class: "edit_client_elment",
          modelValue: _ctx.newPhone,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.newPhone) = $event)),
          placeholder: "+7 (000) 000-00-00",
          label: _ctx.$t('check_phone_number.new_phone_title'),
          height: "22",
          errorText: _ctx.phoneErrorText,
          onFocus: _cache[1] || (_cache[1] = $event => (_ctx.phoneErrorText = '')),
          clearable: ""
        }, null, 8, ["modelValue", "label", "errorText"]), [
          [_directive_maska, void 0, _ctx.phoneMaskOptions]
        ])
      ]),
      (_ctx.showCodeInput)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_v_input, {
              ref: "codeInput",
              class: "edit_client_elment",
              modelValue: _ctx.code,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.code) = $event)),
              placeholder: "",
              label: _ctx.$t('check_phone_number.code_title'),
              height: "22",
              clearable: ""
            }, null, 8, ["modelValue", "label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.codeErrorText?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.codeErrorText), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("button", {
          class: "primary_button",
          onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.sendCode && _ctx.sendCode(...args))),
          disabled: (!_ctx.phoneMaskValidated || _ctx.isSendCodeButtonDisabled)
        }, _toDisplayString(_ctx.$t('check_phone_number.btn_send_code')), 9, _hoisted_9), [
          [_vShow, _ctx.showSendButton]
        ]),
        _withDirectives(_createElementVNode("button", {
          class: "primary_button",
          onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.checkCode && _ctx.checkCode(...args))),
          disabled: _ctx.isCheckCodeButtonDisabled
        }, _toDisplayString(_ctx.$t('check_phone_number.btn_check_code')), 9, _hoisted_10), [
          [_vShow, _ctx.showCheckButton]
        ]),
        _createElementVNode("button", {
          class: "secondary_button button_space",
          onClick: _cache[5] || (_cache[5] = $event => (_ctx.$emit('close')))
        }, _toDisplayString(_ctx.$t('check_phone_number.btn_cancel')), 1)
      ])
    ])), [
      [_directive_click_outside, _ctx.close]
    ])
  ]))
}